<div class="container">
  <h1 class="title">{{cardHeader$ | async}}</h1>
  
  <div *ngIf="componentName$ | async as componentName">
    <ng-container [ngSwitch]="componentName">
      <div *ngSwitchCase="'list'">
        <app-billing-list #listForm
        ></app-billing-list>
      </div>
         
      <div *ngSwitchCase="'payment'">
        <div>
          <app-billing-payment #paymentForm
          ></app-billing-payment>
        </div>
       
      </div>

      <div *ngSwitchCase="'premium'">
        <app-premium-calculation #premiumForm
        ></app-premium-calculation>
      </div>
    </ng-container>
  </div>

</div>


